var Nt = Object.defineProperty;
var Rt = (r, n, l) => n in r ? Nt(r, n, { enumerable: !0, configurable: !0, writable: !0, value: l }) : r[n] = l;
var Ne = (r, n, l) => (Rt(r, typeof n != "symbol" ? n + "" : n, l), l);
import "./index.css";
import I, { createContext as bt, useContext as We } from "react";
var Ee = { exports: {} }, te = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ye;
function Ct() {
  if (Ye)
    return te;
  Ye = 1;
  var r = I, n = Symbol.for("react.element"), l = Symbol.for("react.fragment"), e = Object.prototype.hasOwnProperty, s = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, d = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(f, o, g) {
    var p, v = {}, C = null, D = null;
    g !== void 0 && (C = "" + g), o.key !== void 0 && (C = "" + o.key), o.ref !== void 0 && (D = o.ref);
    for (p in o)
      e.call(o, p) && !d.hasOwnProperty(p) && (v[p] = o[p]);
    if (f && f.defaultProps)
      for (p in o = f.defaultProps, o)
        v[p] === void 0 && (v[p] = o[p]);
    return { $$typeof: n, type: f, key: C, ref: D, props: v, _owner: s.current };
  }
  return te.Fragment = l, te.jsx = u, te.jsxs = u, te;
}
var ne = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var He;
function wt() {
  return He || (He = 1, process.env.NODE_ENV !== "production" && function() {
    var r = I, n = Symbol.for("react.element"), l = Symbol.for("react.portal"), e = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), f = Symbol.for("react.context"), o = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), T = Symbol.iterator, re = "@@iterator";
    function ie(t) {
      if (t === null || typeof t != "object")
        return null;
      var i = T && t[T] || t[re];
      return typeof i == "function" ? i : null;
    }
    var O = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(t) {
      {
        for (var i = arguments.length, c = new Array(i > 1 ? i - 1 : 0), m = 1; m < i; m++)
          c[m - 1] = arguments[m];
        le("error", t, c);
      }
    }
    function le(t, i, c) {
      {
        var m = O.ReactDebugCurrentFrame, y = m.getStackAddendum();
        y !== "" && (i += "%s", c = c.concat([y]));
        var j = c.map(function(h) {
          return String(h);
        });
        j.unshift("Warning: " + i), Function.prototype.apply.call(console[t], console, j);
      }
    }
    var se = !1, oe = !1, ce = !1, de = !1, ue = !1, W;
    W = Symbol.for("react.module.reference");
    function fe(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === e || t === d || ue || t === s || t === g || t === p || de || t === D || se || oe || ce || typeof t == "object" && t !== null && (t.$$typeof === C || t.$$typeof === v || t.$$typeof === u || t.$$typeof === f || t.$$typeof === o || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === W || t.getModuleId !== void 0));
    }
    function me(t, i, c) {
      var m = t.displayName;
      if (m)
        return m;
      var y = i.displayName || i.name || "";
      return y !== "" ? c + "(" + y + ")" : c;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function S(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case e:
          return "Fragment";
        case l:
          return "Portal";
        case d:
          return "Profiler";
        case s:
          return "StrictMode";
        case g:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var i = t;
            return Y(i) + ".Consumer";
          case u:
            var c = t;
            return Y(c._context) + ".Provider";
          case o:
            return me(t, t.render, "ForwardRef");
          case v:
            var m = t.displayName || null;
            return m !== null ? m : S(t.type) || "Memo";
          case C: {
            var y = t, j = y._payload, h = y._init;
            try {
              return S(h(j));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, $ = 0, H, q, J, G, K, Q, X;
    function Z() {
    }
    Z.__reactDisabledLog = !0;
    function pe() {
      {
        if ($ === 0) {
          H = console.log, q = console.info, J = console.warn, G = console.error, K = console.group, Q = console.groupCollapsed, X = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        $++;
      }
    }
    function ge() {
      {
        if ($--, $ === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, t, {
              value: H
            }),
            info: P({}, t, {
              value: q
            }),
            warn: P({}, t, {
              value: J
            }),
            error: P({}, t, {
              value: G
            }),
            group: P({}, t, {
              value: K
            }),
            groupCollapsed: P({}, t, {
              value: Q
            }),
            groupEnd: P({}, t, {
              value: X
            })
          });
        }
        $ < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var L = O.ReactCurrentDispatcher, M;
    function xe(t, i, c) {
      {
        if (M === void 0)
          try {
            throw Error();
          } catch (y) {
            var m = y.stack.trim().match(/\n( *(at )?)/);
            M = m && m[1] || "";
          }
        return `
` + M + t;
      }
    }
    var Re = !1, ve;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      ve = new Xe();
    }
    function Ae(t, i) {
      if (!t || Re)
        return "";
      {
        var c = ve.get(t);
        if (c !== void 0)
          return c;
      }
      var m;
      Re = !0;
      var y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var j;
      j = L.current, L.current = null, pe();
      try {
        if (i) {
          var h = function() {
            throw Error();
          };
          if (Object.defineProperty(h.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(h, []);
            } catch (k) {
              m = k;
            }
            Reflect.construct(t, [], h);
          } else {
            try {
              h.call();
            } catch (k) {
              m = k;
            }
            t.call(h.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (k) {
            m = k;
          }
          t();
        }
      } catch (k) {
        if (k && m && typeof k.stack == "string") {
          for (var x = k.stack.split(`
`), E = m.stack.split(`
`), R = x.length - 1, b = E.length - 1; R >= 1 && b >= 0 && x[R] !== E[b]; )
            b--;
          for (; R >= 1 && b >= 0; R--, b--)
            if (x[R] !== E[b]) {
              if (R !== 1 || b !== 1)
                do
                  if (R--, b--, b < 0 || x[R] !== E[b]) {
                    var A = `
` + x[R].replace(" at new ", " at ");
                    return t.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", t.displayName)), typeof t == "function" && ve.set(t, A), A;
                  }
                while (R >= 1 && b >= 0);
              break;
            }
        }
      } finally {
        Re = !1, L.current = j, ge(), Error.prepareStackTrace = y;
      }
      var z = t ? t.displayName || t.name : "", Ue = z ? xe(z) : "";
      return typeof t == "function" && ve.set(t, Ue), Ue;
    }
    function Ze(t, i, c) {
      return Ae(t, !1);
    }
    function et(t) {
      var i = t.prototype;
      return !!(i && i.isReactComponent);
    }
    function he(t, i, c) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ae(t, et(t));
      if (typeof t == "string")
        return xe(t);
      switch (t) {
        case g:
          return xe("Suspense");
        case p:
          return xe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case o:
            return Ze(t.render);
          case v:
            return he(t.type, i, c);
          case C: {
            var m = t, y = m._payload, j = m._init;
            try {
              return he(j(y), i, c);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, Te = {}, Pe = O.ReactDebugCurrentFrame;
    function je(t) {
      if (t) {
        var i = t._owner, c = he(t.type, t._source, i ? i.type : null);
        Pe.setExtraStackFrame(c);
      } else
        Pe.setExtraStackFrame(null);
    }
    function tt(t, i, c, m, y) {
      {
        var j = Function.call.bind(ye);
        for (var h in t)
          if (j(t, h)) {
            var x = void 0;
            try {
              if (typeof t[h] != "function") {
                var E = Error((m || "React class") + ": " + c + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[h](i, h, m, c, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (R) {
              x = R;
            }
            x && !(x instanceof Error) && (je(y), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", c, h, typeof x), je(null)), x instanceof Error && !(x.message in Te) && (Te[x.message] = !0, je(y), w("Failed %s type: %s", c, x.message), je(null));
          }
      }
    }
    var nt = Array.isArray;
    function be(t) {
      return nt(t);
    }
    function at(t) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, c = i && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return c;
      }
    }
    function rt(t) {
      try {
        return Oe(t), !1;
      } catch {
        return !0;
      }
    }
    function Oe(t) {
      return "" + t;
    }
    function ke(t) {
      if (rt(t))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", at(t)), Oe(t);
    }
    var ee = O.ReactCurrentOwner, it = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ie, $e, Ce;
    Ce = {};
    function lt(t) {
      if (ye.call(t, "ref")) {
        var i = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function st(t) {
      if (ye.call(t, "key")) {
        var i = Object.getOwnPropertyDescriptor(t, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function ot(t, i) {
      if (typeof t.ref == "string" && ee.current && i && ee.current.stateNode !== i) {
        var c = S(ee.current.type);
        Ce[c] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', S(ee.current.type), t.ref), Ce[c] = !0);
      }
    }
    function ct(t, i) {
      {
        var c = function() {
          Ie || (Ie = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        c.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: c,
          configurable: !0
        });
      }
    }
    function dt(t, i) {
      {
        var c = function() {
          $e || ($e = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        c.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: c,
          configurable: !0
        });
      }
    }
    var ut = function(t, i, c, m, y, j, h) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: i,
        ref: c,
        props: h,
        // Record the component responsible for creating this element.
        _owner: j
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function ft(t, i, c, m, y) {
      {
        var j, h = {}, x = null, E = null;
        c !== void 0 && (ke(c), x = "" + c), st(i) && (ke(i.key), x = "" + i.key), lt(i) && (E = i.ref, ot(i, y));
        for (j in i)
          ye.call(i, j) && !it.hasOwnProperty(j) && (h[j] = i[j]);
        if (t && t.defaultProps) {
          var R = t.defaultProps;
          for (j in R)
            h[j] === void 0 && (h[j] = R[j]);
        }
        if (x || E) {
          var b = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && ct(h, b), E && dt(h, b);
        }
        return ut(t, x, E, y, m, ee.current, h);
      }
    }
    var we = O.ReactCurrentOwner, Be = O.ReactDebugCurrentFrame;
    function V(t) {
      if (t) {
        var i = t._owner, c = he(t.type, t._source, i ? i.type : null);
        Be.setExtraStackFrame(c);
      } else
        Be.setExtraStackFrame(null);
    }
    var De;
    De = !1;
    function _e(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Fe() {
      {
        if (we.current) {
          var t = S(we.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function mt(t) {
      {
        if (t !== void 0) {
          var i = t.fileName.replace(/^.*[\\\/]/, ""), c = t.lineNumber;
          return `

Check your code at ` + i + ":" + c + ".";
        }
        return "";
      }
    }
    var Le = {};
    function pt(t) {
      {
        var i = Fe();
        if (!i) {
          var c = typeof t == "string" ? t : t.displayName || t.name;
          c && (i = `

Check the top-level render call using <` + c + ">.");
        }
        return i;
      }
    }
    function Me(t, i) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var c = pt(i);
        if (Le[c])
          return;
        Le[c] = !0;
        var m = "";
        t && t._owner && t._owner !== we.current && (m = " It was passed a child from " + S(t._owner.type) + "."), V(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', c, m), V(null);
      }
    }
    function Ve(t, i) {
      {
        if (typeof t != "object")
          return;
        if (be(t))
          for (var c = 0; c < t.length; c++) {
            var m = t[c];
            _e(m) && Me(m, i);
          }
        else if (_e(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var y = ie(t);
          if (typeof y == "function" && y !== t.entries)
            for (var j = y.call(t), h; !(h = j.next()).done; )
              _e(h.value) && Me(h.value, i);
        }
      }
    }
    function gt(t) {
      {
        var i = t.type;
        if (i == null || typeof i == "string")
          return;
        var c;
        if (typeof i == "function")
          c = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === o || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === v))
          c = i.propTypes;
        else
          return;
        if (c) {
          var m = S(i);
          tt(c, t.props, "prop", m, t);
        } else if (i.PropTypes !== void 0 && !De) {
          De = !0;
          var y = S(i);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", y || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xt(t) {
      {
        for (var i = Object.keys(t.props), c = 0; c < i.length; c++) {
          var m = i[c];
          if (m !== "children" && m !== "key") {
            V(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), V(null);
            break;
          }
        }
        t.ref !== null && (V(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), V(null));
      }
    }
    function ze(t, i, c, m, y, j) {
      {
        var h = fe(t);
        if (!h) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = mt(y);
          E ? x += E : x += Fe();
          var R;
          t === null ? R = "null" : be(t) ? R = "array" : t !== void 0 && t.$$typeof === n ? (R = "<" + (S(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : R = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, x);
        }
        var b = ft(t, i, c, y, j);
        if (b == null)
          return b;
        if (h) {
          var A = i.children;
          if (A !== void 0)
            if (m)
              if (be(A)) {
                for (var z = 0; z < A.length; z++)
                  Ve(A[z], t);
                Object.freeze && Object.freeze(A);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ve(A, t);
        }
        return t === e ? xt(b) : gt(b), b;
      }
    }
    function vt(t, i, c) {
      return ze(t, i, c, !0);
    }
    function ht(t, i, c) {
      return ze(t, i, c, !1);
    }
    var yt = ht, jt = vt;
    ne.Fragment = e, ne.jsx = yt, ne.jsxs = jt;
  }()), ne;
}
process.env.NODE_ENV === "production" ? Ee.exports = Ct() : Ee.exports = wt();
var a = Ee.exports;
class Dt {
  constructor(n) {
    Ne(this, "_bundle");
    Ne(this, "_composition");
    Ne(this, "_entries");
    this._bundle = n, this._composition = this.composition, this._entries = this.entries;
  }
  get bundle() {
    return this._bundle;
  }
  get composition() {
    var n, l;
    if (!this._composition) {
      const e = (l = (n = this.bundle.entry) == null ? void 0 : n.find(
        (s) => {
          var d;
          return ((d = s.resource) == null ? void 0 : d.resourceType.toLowerCase()) === "composition";
        }
      )) == null ? void 0 : l.resource;
      if (!e)
        throw new Error("No composition found in bundle");
      this._composition = e;
    }
    return this._composition;
  }
  get entries() {
    return this._entries || (this._entries = this.bundle.entry ?? []), this._entries;
  }
  get details() {
    var n, l;
    return {
      title: this.composition.title,
      date: this.composition.date ?? ((n = this.composition.meta) == null ? void 0 : n.lastUpdated) ?? this.bundle.timestamp,
      authors: (l = this.composition.author) == null ? void 0 : l.map((e) => this.getResource(e.reference)).filter((e) => e),
      status: this.composition.status
    };
  }
  parseHumanName(n) {
    return n ? [
      n.prefix ?? "",
      n.text ?? [n.given ?? "", n.family ?? ""].join(" ").trim(),
      n.suffix ?? ""
    ].join(" ").trim() : "";
  }
  getAuthorName(n) {
    var l, e, s, d;
    if (!n)
      return null;
    switch (n.resourceType) {
      case "Patient":
        return this.parseHumanName((l = n.name) == null ? void 0 : l[0]);
      case "Practitioner":
        return this.parseHumanName((e = n.name) == null ? void 0 : e[0]);
      case "PractitionerRole":
        return `${(s = n.practitioner) == null ? void 0 : s.display}`;
      case "Organization":
        return `${n.name}`;
      case "Device":
        return `${n.deviceName}`;
      case "RelatedPerson":
        return this.parseHumanName((d = n.name) == null ? void 0 : d[0]);
      default:
        return "";
    }
  }
  getConceptDisplay(n) {
    if (!n)
      return null;
    if (n.text)
      return n.text;
    if (n.coding)
      for (const l of n.coding) {
        const e = this.getCodingDisplay(l);
        if (e)
          return e;
      }
    return "";
  }
  getCodingDisplay(n) {
    return n.display ?? n.code ?? "";
  }
  getObservationValue(n) {
    var l, e, s, d, u, f, o, g, p, v, C, D, T, re, ie, O, w, le, se, oe, ce, de, ue, W, fe, me, Y, S, P, $, H, q, J, G, K, Q, X, Z, pe, ge, L, M;
    return "valueString" in n ? n.valueString ?? "" : "valueQuantity" in n ? ((e = (l = n.valueQuantity) == null ? void 0 : l.value) == null ? void 0 : e.toString()) + " " + ((s = n.valueQuantity) == null ? void 0 : s.unit) : "valueCodeableConcept" in n ? this.getConceptDisplay(n.valueCodeableConcept) ?? "" : "valueBoolean" in n ? ((d = n.valueBoolean) == null ? void 0 : d.toString()) ?? "" : "valueInteger" in n ? ((u = n.valueInteger) == null ? void 0 : u.toString()) ?? "" : "valueDateTime" in n ? ((f = n.valueDateTime) == null ? void 0 : f.toString()) ?? "" : "valueTime" in n ? ((o = n.valueTime) == null ? void 0 : o.toString()) ?? "" : "valueRange" in n ? ((v = (p = (g = n.valueRange) == null ? void 0 : g.low) == null ? void 0 : p.value) == null ? void 0 : v.toString()) ?? " " + ((D = (C = n.valueRange) == null ? void 0 : C.low) == null ? void 0 : D.unit) ?? " - " + ((ie = (re = (T = n.valueRange) == null ? void 0 : T.high) == null ? void 0 : re.value) == null ? void 0 : ie.toString()) ?? " " + ((w = (O = n.valueRange) == null ? void 0 : O.high) == null ? void 0 : w.unit) ?? "" : "valueRatio" in n ? ((oe = (se = (le = n.valueRatio) == null ? void 0 : le.numerator) == null ? void 0 : se.value) == null ? void 0 : oe.toString()) ?? " " + ((de = (ce = n.valueRatio) == null ? void 0 : ce.numerator) == null ? void 0 : de.unit) ?? " : " + ((fe = (W = (ue = n.valueRatio) == null ? void 0 : ue.denominator) == null ? void 0 : W.value) == null ? void 0 : fe.toString()) ?? " " + ((Y = (me = n.valueRatio) == null ? void 0 : me.denominator) == null ? void 0 : Y.unit) ?? "" : "valueSampledData" in n ? (($ = (P = (S = n.valueSampledData) == null ? void 0 : S.origin) == null ? void 0 : P.value) == null ? void 0 : $.toString()) ?? " " + ((q = (H = n.valueSampledData) == null ? void 0 : H.origin) == null ? void 0 : q.unit) ?? " : " + ((G = (J = n.valueSampledData) == null ? void 0 : J.period) == null ? void 0 : G.toString()) ?? " " + ((Q = (K = n.valueSampledData) == null ? void 0 : K.dimensions) == null ? void 0 : Q.toString()) ?? " " + ((Z = (X = n.valueSampledData) == null ? void 0 : X.data) == null ? void 0 : Z.toString()) ?? "" : "valuePeriod" in n ? ((ge = (pe = n.valuePeriod) == null ? void 0 : pe.start) == null ? void 0 : ge.toString()) ?? " " + ((M = (L = n.valuePeriod) == null ? void 0 : L.end) == null ? void 0 : M.toString()) ?? "" : "";
  }
  getResource(n) {
    var l;
    return n ? ((l = this.entries.find((e) => e.fullUrl === n)) == null ? void 0 : l.resource) ?? null : null;
  }
  get encounter() {
    var n;
    return this.getResource(
      (n = this.composition.encounter) == null ? void 0 : n.reference
    ) ?? null;
  }
}
const Se = bt({
  profile: null
});
function _() {
  if (!We(Se))
    throw new Error("useProfile must be used within a ProfileProvider");
  return We(Se);
}
function _t({
  bundle: r,
  downloadable: n,
  children: l
}) {
  return /* @__PURE__ */ a.jsx(
    Se.Provider,
    {
      value: { profile: new Dt(r), downloadable: n },
      children: l
    }
  );
}
var Je = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, qe = I.createContext && I.createContext(Je), B = globalThis && globalThis.__assign || function() {
  return B = Object.assign || function(r) {
    for (var n, l = 1, e = arguments.length; l < e; l++) {
      n = arguments[l];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (r[s] = n[s]);
    }
    return r;
  }, B.apply(this, arguments);
}, Et = globalThis && globalThis.__rest || function(r, n) {
  var l = {};
  for (var e in r)
    Object.prototype.hasOwnProperty.call(r, e) && n.indexOf(e) < 0 && (l[e] = r[e]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, e = Object.getOwnPropertySymbols(r); s < e.length; s++)
      n.indexOf(e[s]) < 0 && Object.prototype.propertyIsEnumerable.call(r, e[s]) && (l[e[s]] = r[e[s]]);
  return l;
};
function Ge(r) {
  return r && r.map(function(n, l) {
    return I.createElement(n.tag, B({
      key: l
    }, n.attr), Ge(n.child));
  });
}
function ae(r) {
  return function(n) {
    return I.createElement(St, B({
      attr: B({}, r.attr)
    }, n), Ge(r.child));
  };
}
function St(r) {
  var n = function(l) {
    var e = r.attr, s = r.size, d = r.title, u = Et(r, ["attr", "size", "title"]), f = s || l.size || "1em", o;
    return l.className && (o = l.className), r.className && (o = (o ? o + " " : "") + r.className), I.createElement("svg", B({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, l.attr, e, u, {
      className: o,
      style: B(B({
        color: r.color || l.color
      }, l.style), r.style),
      height: f,
      width: f,
      xmlns: "http://www.w3.org/2000/svg"
    }), d && I.createElement("title", null, d), r.children);
  };
  return qe !== void 0 ? I.createElement(qe.Consumer, null, function(l) {
    return n(l);
  }) : n(Je);
}
function At(r) {
  return ae({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z", clipRule: "evenodd" } }] })(r);
}
function Tt(r) {
  return ae({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z", clipRule: "evenodd" } }] })(r);
}
function Ke(r) {
  return ae({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M18.97 3.659a2.25 2.25 0 00-3.182 0l-10.94 10.94a3.75 3.75 0 105.304 5.303l7.693-7.693a.75.75 0 011.06 1.06l-7.693 7.693a5.25 5.25 0 11-7.424-7.424l10.939-10.94a3.75 3.75 0 115.303 5.304L9.097 18.835l-.008.008-.007.007-.002.002-.003.002A2.25 2.25 0 015.91 15.66l7.81-7.81a.75.75 0 011.061 1.06l-7.81 7.81a.75.75 0 001.054 1.068L18.97 6.84a2.25 2.25 0 000-3.182z", clipRule: "evenodd" } }] })(r);
}
function Pt(r) {
  return ae({ tag: "svg", attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" } }] })(r);
}
function Ot(r) {
  return ae({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z", clipRule: "evenodd" } }] })(r);
}
function U(...r) {
  return r.filter(Boolean).join(" ");
}
function N(r, n = !1) {
  return r ? new Date(r).toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
    ...n && {
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    }
  }) : null;
}
function kt() {
  const { profile: r, downloadable: n } = _(), { title: l, authors: e, date: s, status: d } = r.details;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight", children: l }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex items-end justify-between", children: [
      /* @__PURE__ */ a.jsx("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ a.jsxs("div", { className: "mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:gap-x-6", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "mt-2 flex items-center text-sm text-gray-500", children: [
          /* @__PURE__ */ a.jsx(
            Pt,
            {
              className: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }
          ),
          /* @__PURE__ */ a.jsx("p", { className: "flex items-center gap-2", children: e == null ? void 0 : e.map((u, f) => /* @__PURE__ */ a.jsxs("span", { className: "cursor-pointer hover:text-gray-700", children: [
            r.getAuthorName(u),
            " ",
            f < e.length - 1 && "•"
          ] })) })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "mt-2 flex items-center text-sm text-gray-500", children: [
          /* @__PURE__ */ a.jsx(
            Ot,
            {
              className: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }
          ),
          d
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "mt-2 flex items-center text-sm text-gray-500", children: [
          /* @__PURE__ */ a.jsx(
            Tt,
            {
              className: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }
          ),
          N(s)
        ] })
      ] }) }),
      n && /* @__PURE__ */ a.jsx("div", { className: "flex lg:ml-4", children: /* @__PURE__ */ a.jsx("span", { children: /* @__PURE__ */ a.jsxs(
        "button",
        {
          type: "button",
          onClick: () => {
            const u = new Blob([JSON.stringify(r.bundle)], {
              type: "application/json"
            }), f = URL.createObjectURL(u), o = document.createElement("a");
            o.href = f, o.download = "bundle.json", o.click();
          },
          className: "inline-flex items-center rounded-md bg-white px-3 py-2 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
          children: [
            /* @__PURE__ */ a.jsx(
              At,
              {
                className: "-ml-0.5 mr-1.5 h-4 w-4",
                "aria-hidden": "true"
              }
            ),
            "Download Raw FHIR Bundle"
          ]
        }
      ) }) })
    ] })
  ] });
}
function F({ heads: r, rows: n, className: l }) {
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      className: U(
        "-mx-4 mt-10 overflow-x-auto ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg",
        l
      ),
      children: /* @__PURE__ */ a.jsxs("table", { className: "min-w-full divide-y divide-gray-300", children: [
        /* @__PURE__ */ a.jsx("thead", { children: /* @__PURE__ */ a.jsx("tr", { children: r.map((e) => /* @__PURE__ */ a.jsx(
          "th",
          {
            scope: "col",
            className: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6",
            children: e
          }
        )) }) }),
        /* @__PURE__ */ a.jsx("tbody", { children: n.map((e, s) => /* @__PURE__ */ a.jsx("tr", { children: e.map((d, u) => /* @__PURE__ */ a.jsx(
          "td",
          {
            className: U(
              s === 0 ? "" : "border-t border-gray-200",
              "px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
            ),
            children: d
          },
          u
        )) }, s)) })
      ] })
    }
  );
}
function Qe({ references: r }) {
  const { profile: n } = _();
  if (r.length === 0)
    return null;
  const l = r.map(
    (e) => n.getResource(e.reference)
  ).filter((e) => e && (e == null ? void 0 : e.resourceType) === "Observation").map((e) => {
    var s, d;
    return [
      e.effectiveDateTime ? N(e.effectiveDateTime, !0) : null,
      n.getConceptDisplay(e.code),
      /* @__PURE__ */ a.jsxs("p", { children: [
        n.getObservationValue(e),
        /* @__PURE__ */ a.jsx("p", { className: "flex flex-col gap-1", children: (s = e.component) == null ? void 0 : s.map((u) => /* @__PURE__ */ a.jsxs("span", { children: [
          n.getConceptDisplay(u.code),
          " :",
          " ",
          n.getObservationValue(u)
        ] })) })
      ] }),
      [e.status, (d = e.interpretation) == null ? void 0 : d[0].text].filter(Boolean).join(" - ")
    ];
  });
  return /* @__PURE__ */ a.jsx(
    F,
    {
      heads: ["Date", "Observation", "Value", "Status & Interpretation"],
      rows: l
    }
  );
}
function It({ references: r }) {
  const { profile: n } = _();
  if (r.length === 0)
    return null;
  const l = r.map(
    (e) => n.getResource(e.reference)
  ).filter((e) => e && (e == null ? void 0 : e.resourceType) === "Immunization").map((e) => {
    var s, d, u, f;
    return [
      e.occurrenceDateTime ? N(e.occurrenceDateTime) : "NA",
      n.getConceptDisplay(e.vaccineCode),
      e.lotNumber ?? "NA",
      e.route ? n.getConceptDisplay(e.route) : "NA",
      n.getResource(
        (s = e.manufacturer) == null ? void 0 : s.reference
      ).name ?? "NA",
      ((d = e.protocolApplied) == null ? void 0 : d[0].doseNumberPositiveInt) ?? ((u = e.protocolApplied) == null ? void 0 : u[0].doseNumberString) ?? "NA",
      ((f = e.reasonCode) == null ? void 0 : f.map((o) => n.getConceptDisplay(o)).join(", ")) ?? "NA",
      e.status
    ];
  });
  return /* @__PURE__ */ a.jsx(
    F,
    {
      heads: [
        "Date",
        "Vaccine",
        "Lot Number",
        "Route",
        "Manufacturer",
        "Dose",
        "Reason",
        "Status"
      ],
      rows: l
    }
  );
}
function $t({ references: r }) {
  const { profile: n } = _();
  if (r.length === 0)
    return null;
  const l = r.map(
    (e) => n.getResource(e.reference)
  ).filter(
    (e) => e && (e == null ? void 0 : e.resourceType) === "MedicationRequest"
  ).map((e) => {
    var s, d, u, f, o, g;
    return [
      e.authoredOn ? N(e.authoredOn) : "NA",
      n.getConceptDisplay(
        (d = n.getResource(
          (s = e.medicationReference) == null ? void 0 : s.reference
        )) == null ? void 0 : d.code
      ) ?? n.getConceptDisplay(e.medicationCodeableConcept) ?? "NA",
      ((u = e.dosageInstruction) == null ? void 0 : u.map((p) => {
        var v;
        return [
          p.text,
          ...((v = p.additionalInstruction) == null ? void 0 : v.map(
            (C) => n.getConceptDisplay(C)
          )) ?? []
        ];
      }).filter(Boolean).join(", ")) || "NA",
      [
        ...((f = e.reasonReference) == null ? void 0 : f.map(
          (p) => n.getConceptDisplay(
            n.getResource(p.reference).code
          )
        )) ?? [],
        ...((o = e.reasonCode) == null ? void 0 : o.map(
          (p) => n.getConceptDisplay(p)
        )) ?? []
      ].filter(Boolean).join(", ") || "NA",
      e.status,
      [
        ...((g = e.note) == null ? void 0 : g.map((p) => p.text)) ?? [],
        e.priority && `Priority: ${e.priority}`
      ].filter(Boolean).join(", ") || "NA"
    ];
  });
  return /* @__PURE__ */ a.jsx(
    F,
    {
      heads: [
        "Date",
        "Medication",
        "Dose",
        "Reason",
        "Status",
        "Additional Info"
      ],
      rows: l
    }
  );
}
function Bt({ references: r }) {
  const { profile: n } = _();
  if (r.length === 0)
    return null;
  const l = r.map(
    (e) => n.getResource(e.reference)
  ).filter((e) => e && (e == null ? void 0 : e.resourceType) === "Condition").map((e) => {
    var s, d, u, f;
    return [
      e.recordedDate ? N(e.recordedDate) : "NA",
      n.getConceptDisplay(e.code) ?? "NA",
      ((s = e.category) == null ? void 0 : s.map((o) => n.getConceptDisplay(o)).filter(Boolean).join(", ")) || "NA",
      n.getConceptDisplay(e.severity) ?? "NA",
      [
        `Clinical Status: ${n.getConceptDisplay(
          e.clinicalStatus
        )}`,
        `Verification Status: ${n.getConceptDisplay(
          e.verificationStatus
        )}`
      ].join(", "),
      [
        e.onsetDateTime ? `Onset: ${N(e.onsetDateTime) ?? "NA"}` : "",
        e.onsetAge ? `Onset: ${e.onsetAge.value ?? "NA"} ${e.onsetAge.unit}` : "",
        e.onsetPeriod ? `Onset: ${N(e.onsetPeriod.start) ?? "NA"} - ${N(e.onsetPeriod.end) ?? "NA"}` : "",
        e.onsetRange ? `Onset: ${((d = e.onsetRange.low) == null ? void 0 : d.value) ?? "NA"} - ${((u = e.onsetRange.high) == null ? void 0 : u.value) ?? "NA"}` : "",
        e.onsetString ? `Onset: ${e.onsetString ?? "NA"}` : "",
        ...((f = e.note) == null ? void 0 : f.map((o) => o.text)) ?? []
      ].filter(Boolean).join(", ") || "NA"
    ];
  });
  return /* @__PURE__ */ a.jsx(
    F,
    {
      heads: [
        "Date",
        "Condition",
        "Category",
        "Severity",
        "Status",
        "Additional Info"
      ],
      rows: l
    }
  );
}
function Ft({ references: r }) {
  const { profile: n } = _();
  if (r.length === 0)
    return null;
  const l = r.map(
    (e) => n.getResource(e.reference)
  ).filter(
    (e) => e && (e == null ? void 0 : e.resourceType) === "AllergyIntolerance"
  ).map((e) => {
    var s;
    return [
      e.recordedDate ? N(e.recordedDate) : "NA",
      n.getConceptDisplay(e.code) ?? "NA",
      [
        `Clinical Status: ${n.getConceptDisplay(
          e.clinicalStatus
        )}`,
        `Verification Status: ${n.getConceptDisplay(
          e.verificationStatus
        )}`
      ].join(", "),
      [...((s = e.note) == null ? void 0 : s.map((d) => d.text)) ?? []].filter(Boolean).join(", ")
    ];
  });
  return /* @__PURE__ */ a.jsx(
    F,
    {
      heads: ["Date", "Allergy", "Status", "Additional Info"],
      rows: l
    }
  );
}
function Lt({ document: r }) {
  var e, s, d, u, f;
  const { profile: n } = _(), l = [
    {
      label: "Authors",
      value: (e = r.author) == null ? void 0 : e.map(
        (o) => n.getAuthorName(
          n.getResource(o.reference)
        )
      ).filter(Boolean).join(", ")
    },
    { label: "Date", value: N(r.date) },
    { label: "Description", value: r.description },
    { label: "Status", value: r.status },
    { label: "Document Status", value: r.docStatus },
    {
      label: "Context",
      value: ((d = (s = r.context) == null ? void 0 : s.encounter) == null ? void 0 : d.map((o) => o.display).filter(Boolean).join(", ")) || ((f = (u = r.context) == null ? void 0 : u.encounter) == null ? void 0 : f.map(
        (o) => {
          var g, p;
          return (p = (g = n.getResource(o.reference)) == null ? void 0 : g.type) == null ? void 0 : p.map((v) => n.getConceptDisplay(v)).filter(Boolean).join("; ");
        }
      ).filter(Boolean).join(", ")) || "NA"
    }
  ];
  return /* @__PURE__ */ a.jsxs("div", { className: "", children: [
    /* @__PURE__ */ a.jsx("dl", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3", children: l.map(
      (o) => o.value ? /* @__PURE__ */ a.jsxs("div", { className: "px-4 py-4 sm:col-span-1 sm:px-0", children: [
        /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: o.label }),
        /* @__PURE__ */ a.jsx("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:mt-2", children: o.value })
      ] }) : null
    ) }),
    /* @__PURE__ */ a.jsxs("div", { className: "px-4 py-4 sm:col-span-2 sm:px-0", children: [
      /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Attachments" }),
      /* @__PURE__ */ a.jsx("dd", { className: "mt-2 text-sm text-gray-900", children: /* @__PURE__ */ a.jsx(
        "ul",
        {
          role: "list",
          className: "divide-y divide-gray-100 rounded-md border border-gray-200",
          children: r.content.map((o) => {
            var g, p, v, C, D, T;
            return /* @__PURE__ */ a.jsxs("li", { className: "flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex w-0 flex-1 items-center", children: [
                /* @__PURE__ */ a.jsx(
                  Ke,
                  {
                    className: "h-5 w-5 flex-shrink-0 text-gray-400",
                    "aria-hidden": "true"
                  }
                ),
                /* @__PURE__ */ a.jsxs("div", { className: "ml-4 flex min-w-0 flex-1 gap-2", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "truncate font-medium", children: ((g = o.attachment) == null ? void 0 : g.title) ?? "Link to document" }),
                  ((p = o.attachment) == null ? void 0 : p.size) && /* @__PURE__ */ a.jsxs("span", { className: "flex-shrink-0 text-gray-400", children: [
                    ((v = o.attachment) == null ? void 0 : v.size) / 1e3,
                    " KB"
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "ml-4 flex-shrink-0", children: /* @__PURE__ */ a.jsx(
                "a",
                {
                  href: ((C = o.attachment) == null ? void 0 : C.url) ?? URL.createObjectURL(
                    new Blob([atob(((D = o.attachment) == null ? void 0 : D.data) ?? "")], {
                      type: ((T = o.attachment) == null ? void 0 : T.contentType) ?? "application/octet-stream"
                    })
                  ) ?? "#",
                  className: "font-medium text-indigo-600 hover:text-indigo-500",
                  children: "Download"
                }
              ) })
            ] });
          })
        }
      ) })
    ] })
  ] });
}
function Mt({ references: r, className: n }) {
  const { profile: l } = _();
  if (r.length === 0)
    return null;
  const e = r.map(
    (s) => l.getResource(s.reference)
  ).filter(
    (s) => s && (s == null ? void 0 : s.resourceType) === "DocumentReference"
  );
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      className: U(
        "-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg p-6 min-w-full divide-y divide-gray-300",
        n
      ),
      children: e.map((s, d) => /* @__PURE__ */ a.jsx(Lt, { document: s }, d))
    }
  );
}
function Vt({ references: r }) {
  const { profile: n } = _();
  if (r.length === 0)
    return null;
  const l = r.map(
    (e) => n.getResource(e.reference)
  ).filter((e) => e && (e == null ? void 0 : e.resourceType) === "Procedure").map((e) => {
    var s, d, u, f, o, g, p;
    return [
      // TODO: add a helper function to get the diplay of date
      N(e.performedDateTime) ?? (e.performedAge && `${e.performedAge.value ?? "NA"} ${(s = e.performedAge) == null ? void 0 : s.unit}`) ?? (e.performedPeriod && `${N(e.performedPeriod.start) ?? "NA"} - ${N(e.performedPeriod.end) ?? "NA"}`) ?? (e.performedRange && `${((d = e.performedRange.low) == null ? void 0 : d.value) ?? "NA"} - ${((u = e.performedRange.high) == null ? void 0 : u.value) ?? "NA"}`) ?? (e.performedString && `${e.performedString ?? "NA"}`) ?? "NA",
      n.getConceptDisplay(e.code) ?? "NA",
      n.getConceptDisplay(e.category) ?? "NA",
      [e.status, n.getConceptDisplay(e.statusReason)].filter(Boolean).join(" - ") || "NA",
      n.getConceptDisplay(e.outcome) ?? "NA",
      [
        e.performer && "Performer: " + ((f = e.performer) == null ? void 0 : f.map(
          (v) => n.getAuthorName(
            n.getResource(v.actor.reference)
          ) + (v.function ? `(${n.getConceptDisplay(v.function)})` : "")
        ).filter(Boolean).join(", ")),
        e.reasonCode && "Reason: " + ((o = e.reasonCode) == null ? void 0 : o.map((v) => n.getConceptDisplay(v)).filter(Boolean).join(", ")),
        e.bodySite && "Body Site: " + ((g = e.bodySite) == null ? void 0 : g.map((v) => n.getConceptDisplay(v)).filter(Boolean).join(", ")),
        e.complication && "Complication: " + ((p = e.complication) == null ? void 0 : p.map((v) => n.getConceptDisplay(v)).filter(Boolean).join(", "))
      ].filter(Boolean).join(", ") || "NA"
    ];
  });
  return /* @__PURE__ */ a.jsx(
    F,
    {
      heads: [
        "Date",
        "Procedure",
        "Category",
        "Status",
        "Outcome",
        "Additional Info"
      ],
      rows: l
    }
  );
}
function zt({ references: r }) {
  const { profile: n } = _();
  if (r.length === 0)
    return null;
  const l = r.map(
    (e) => n.getResource(e.reference)
  ).filter((e) => e && (e == null ? void 0 : e.resourceType) === "Appointment").map((e) => {
    var s, d, u, f, o;
    return [
      [N(e.start, !0), N(e.end, !0)].filter(Boolean).join(" - ") || "NA",
      [
        e.text,
        e.description,
        ...((s = e.serviceCategory) == null ? void 0 : s.map(
          (g) => n.getConceptDisplay(g)
        )) ?? [],
        ...((d = e.serviceType) == null ? void 0 : d.map(
          (g) => n.getConceptDisplay(g)
        )) ?? [],
        ...((u = e.specialty) == null ? void 0 : u.map((g) => n.getConceptDisplay(g))) ?? [],
        n.getConceptDisplay(e.appointmentType),
        ...((f = e.reasonCode) == null ? void 0 : f.map(
          (g) => n.getConceptDisplay(g)
        )) ?? []
      ].filter(Boolean).join(", ") || "NA",
      [e.status, n.getConceptDisplay(e.cancelationReason)].filter(Boolean).join(" - ") || "NA",
      [
        e.priority && `Priority: ${e.priority}`,
        e.created && `Created On: ${N(e.created)}`,
        e.comment,
        e.patientInstruction,
        "Participants: " + ((o = e.participant) == null ? void 0 : o.map(
          (g) => {
            var p;
            return n.getAuthorName(
              n.getResource((p = g.actor) == null ? void 0 : p.reference)
            ) + (g.status ? ` (${g.status})` : "");
          }
        ).filter(Boolean).join(", "))
      ].filter(Boolean).join(", ") || "NA"
    ];
  });
  return /* @__PURE__ */ a.jsx(
    F,
    {
      heads: ["Time", "Appointment", "Status", "Additional Info"],
      rows: l
    }
  );
}
function Ut({ references: r }) {
  const { profile: n } = _();
  if (r.length === 0)
    return null;
  const l = r.map(
    (e) => n.getResource(e.reference)
  ).filter((e) => e && (e == null ? void 0 : e.resourceType) === "CarePlan").map((e) => {
    var s, d, u;
    return [
      (e.period && `${N(e.period.start) ?? "NA"} - ${N(e.period.end) ?? "NA"}`) ?? "NA",
      [e.title, e.description, e.text].filter(Boolean).join(", ") || "NA",
      n.getAuthorName(
        n.getResource((s = e.author) == null ? void 0 : s.reference)
      ) ?? "NA",
      `${e.status} - ${e.intent}`,
      ((d = e.category) == null ? void 0 : d.map((f) => n.getConceptDisplay(f)).filter(Boolean).join(", ")) || "NA",
      [
        e.created && `Created On: ${N(e.created)}`,
        ...((u = e.note) == null ? void 0 : u.map((f) => f.text)) ?? []
      ].filter(Boolean).join(", ") || "NA"
    ];
  });
  return /* @__PURE__ */ a.jsx(
    F,
    {
      heads: [
        "Period",
        "Care Plan",
        "Author",
        "Status - Intent",
        "Categories",
        "Additional Info"
      ],
      rows: l
    }
  );
}
function Wt({ report: r }) {
  var e, s, d, u, f;
  const { profile: n } = _(), l = [
    {
      label: "Date",
      value: N(r.effectiveDateTime) ?? [
        N((e = r.effectivePeriod) == null ? void 0 : e.start),
        N((s = r.effectivePeriod) == null ? void 0 : s.end)
      ].filter(Boolean).join(" - ")
    },
    { label: "Status", value: r.status },
    {
      label: "Categories",
      value: (d = r.category) == null ? void 0 : d.map((o) => n.getConceptDisplay(o)).filter(Boolean).join(", ")
    },
    { label: "Conclusion", value: r.conclusion },
    {
      label: "Performers",
      value: (u = r.performer) == null ? void 0 : u.map(
        (o) => n.getAuthorName(
          n.getResource(o.reference)
        )
      ).filter(Boolean).join(", ")
    },
    {
      label: "Interpreters",
      value: (f = r.resultsInterpreter) == null ? void 0 : f.map(
        (o) => n.getAuthorName(
          n.getResource(o.reference)
        )
      ).filter(Boolean).join(", ")
    }
  ];
  return /* @__PURE__ */ a.jsxs("div", { className: "", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "px-4 py-6 sm:px-6", children: [
      /* @__PURE__ */ a.jsx("h3", { className: "text-base font-semibold leading-7 text-gray-900", children: n.getConceptDisplay(r.code) }),
      r.text && /* @__PURE__ */ a.jsx("p", { className: "mt-1 max-w-2xl text-sm leading-6 text-gray-500", children: r.text.div })
    ] }),
    /* @__PURE__ */ a.jsx("dl", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3", children: l.map(
      (o) => o.value ? /* @__PURE__ */ a.jsxs("div", { className: "px-4 py-4 sm:col-span-1 sm:px-0", children: [
        /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: o.label }),
        /* @__PURE__ */ a.jsx("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:mt-2", children: o.value })
      ] }) : null
    ) }),
    /* @__PURE__ */ a.jsxs("div", { className: "px-4 py-4 sm:col-span-2 sm:px-0", children: [
      /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Results" }),
      /* @__PURE__ */ a.jsx("dd", { className: "mt-2 text-sm text-gray-900", children: /* @__PURE__ */ a.jsx(Qe, { references: r.result ?? [] }) })
    ] }),
    r.presentedForm && /* @__PURE__ */ a.jsxs("div", { className: "px-4 py-4 sm:col-span-2 sm:px-0", children: [
      /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Attachments" }),
      /* @__PURE__ */ a.jsx("dd", { className: "mt-2 text-sm text-gray-900", children: /* @__PURE__ */ a.jsx(
        "ul",
        {
          role: "list",
          className: "divide-y divide-gray-100 rounded-md border border-gray-200",
          children: r.presentedForm.map((o) => /* @__PURE__ */ a.jsxs("li", { className: "flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex w-0 flex-1 items-center", children: [
              /* @__PURE__ */ a.jsx(
                Ke,
                {
                  className: "h-5 w-5 flex-shrink-0 text-gray-400",
                  "aria-hidden": "true"
                }
              ),
              /* @__PURE__ */ a.jsxs("div", { className: "ml-4 flex min-w-0 flex-1 gap-2", children: [
                /* @__PURE__ */ a.jsx("span", { className: "truncate font-medium", children: o.title ?? "Link to document" }),
                o.size && /* @__PURE__ */ a.jsxs("span", { className: "flex-shrink-0 text-gray-400", children: [
                  o.size / 1e3,
                  " KB"
                ] })
              ] })
            ] }),
            /* @__PURE__ */ a.jsx("div", { className: "ml-4 flex-shrink-0", children: /* @__PURE__ */ a.jsx(
              "a",
              {
                href: o.url ?? URL.createObjectURL(
                  new Blob([atob(o.data ?? "")], {
                    type: o.contentType ?? "application/octet-stream"
                  })
                ) ?? "#",
                className: "font-medium text-indigo-600 hover:text-indigo-500",
                children: "Download"
              }
            ) })
          ] }))
        }
      ) })
    ] })
  ] });
}
function Yt({ references: r, className: n }) {
  const { profile: l } = _();
  if (r.length === 0)
    return null;
  const e = r.map(
    (s) => l.getResource(s.reference)
  ).filter(
    (s) => s && (s == null ? void 0 : s.resourceType) === "DiagnosticReport"
  );
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      className: U(
        "-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg p-6 min-w-full divide-y divide-gray-300",
        n
      ),
      children: e.map((s, d) => /* @__PURE__ */ a.jsx(Wt, { report: s }, d))
    }
  );
}
function Ht({ section: r }) {
  var s, d, u, f;
  const { profile: n } = _(), e = ((o) => {
    var p;
    return (p = o.entry) == null ? void 0 : p.reduce((v, C) => {
      var T;
      const D = (T = n == null ? void 0 : n.getResource(C.reference)) == null ? void 0 : T.resourceType;
      return console.log(D, C), D && (v[D] = v[D] ?? [], v[D].push(C)), v;
    }, {});
  })(r);
  return /* @__PURE__ */ a.jsxs("div", { className: "mt-6 rounded shadow p-4 pl-6", children: [
    /* @__PURE__ */ a.jsx("div", { className: "sm:flex sm:items-center", children: /* @__PURE__ */ a.jsxs("div", { className: "sm:flex-auto", children: [
      /* @__PURE__ */ a.jsx("h1", { className: "text-base font-semibold leading-6 text-gray-900", children: r.title }),
      /* @__PURE__ */ a.jsx("p", { className: "mt-2 text-sm text-gray-700", children: ((d = (s = r.code) == null ? void 0 : s.coding) == null ? void 0 : d[0].display) ?? ((f = (u = r.code) == null ? void 0 : u.coding) == null ? void 0 : f[0].code) })
    ] }) }),
    /* @__PURE__ */ a.jsx(Qe, { references: (e == null ? void 0 : e.Observation) ?? [] }),
    /* @__PURE__ */ a.jsx(It, { references: (e == null ? void 0 : e.Immunization) ?? [] }),
    /* @__PURE__ */ a.jsx($t, { references: (e == null ? void 0 : e.MedicationRequest) ?? [] }),
    /* @__PURE__ */ a.jsx(Bt, { references: (e == null ? void 0 : e.Condition) ?? [] }),
    /* @__PURE__ */ a.jsx(Ft, { references: (e == null ? void 0 : e.AllergyIntolerance) ?? [] }),
    /* @__PURE__ */ a.jsx(Mt, { references: (e == null ? void 0 : e.DocumentReference) ?? [] }),
    /* @__PURE__ */ a.jsx(Vt, { references: (e == null ? void 0 : e.Procedure) ?? [] }),
    /* @__PURE__ */ a.jsx(zt, { references: (e == null ? void 0 : e.Appointment) ?? [] }),
    /* @__PURE__ */ a.jsx(Ut, { references: (e == null ? void 0 : e.CarePlan) ?? [] }),
    /* @__PURE__ */ a.jsx(Yt, { references: (e == null ? void 0 : e.DiagnosticReport) ?? [] })
  ] });
}
function qt({ className: r }) {
  var e, s, d, u, f;
  const { profile: n } = _(), { encounter: l } = n;
  return l ? /* @__PURE__ */ a.jsxs("div", { className: U("rounded shadow p-4 pl-6", r), children: [
    /* @__PURE__ */ a.jsxs("div", { className: "px-4 sm:px-0", children: [
      /* @__PURE__ */ a.jsx("h3", { className: "text-xl font-semibold leading-7 text-gray-900", children: "Encounter Details" }),
      /* @__PURE__ */ a.jsx("p", { className: "mt-1 max-w-2xl text-sm leading-6 text-gray-500", children: "This includes the dates like admission and discharge, and some extra details." })
    ] }),
    /* @__PURE__ */ a.jsx("div", { className: "mt-6", children: /* @__PURE__ */ a.jsxs("dl", { className: "grid grid-cols-1 sm:grid-cols-2", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0", children: [
        /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Category" }),
        /* @__PURE__ */ a.jsx("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:mt-2", children: l.class.display ?? l.class.code })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0", children: [
        /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Status" }),
        /* @__PURE__ */ a.jsx("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:mt-2", children: l.status })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0", children: [
        /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Start Date" }),
        /* @__PURE__ */ a.jsx("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:mt-2", children: (e = l.period) != null && e.start ? N((s = l.period) == null ? void 0 : s.start) : "Not available" })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0", children: [
        /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "End Date" }),
        /* @__PURE__ */ a.jsx("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:mt-2", children: (d = l.period) != null && d.end ? N((u = l.period) == null ? void 0 : u.end) : "Not available" })
      ] }),
      ((f = l.diagnosis) == null ? void 0 : f.length) && /* @__PURE__ */ a.jsxs("div", { className: "border-t border-gray-100 px-4 py-6 sm:col-span-2 sm:px-0", children: [
        /* @__PURE__ */ a.jsx("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Diagnosis" }),
        /* @__PURE__ */ a.jsx("dd", { className: "mt-2 text-sm text-gray-900", children: /* @__PURE__ */ a.jsx(
          "ul",
          {
            role: "list",
            className: "divide-y divide-gray-100 rounded-md border border-gray-200",
            children: l.diagnosis.map((o) => {
              var g, p;
              return /* @__PURE__ */ a.jsx("li", { className: "flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6", children: /* @__PURE__ */ a.jsx("div", { className: "flex w-0 flex-1 items-center", children: /* @__PURE__ */ a.jsxs("span", { className: "truncate font-medium", children: [
                ((g = o.condition) == null ? void 0 : g.display) ?? ((p = o.condition) == null ? void 0 : p.reference),
                " "
              ] }) }) });
            })
          }
        ) })
      ] })
    ] }) })
  ] }) : /* @__PURE__ */ a.jsx("p", { className: U("text-gray-400 p-4 pl-6", r), children: "No Encounter Found" });
}
function Jt() {
  var l;
  const { profile: r } = _(), { composition: n } = r;
  return /* @__PURE__ */ a.jsxs("main", { className: "max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8 rounded shadow border border-gray-200 w-full flex flex-col gap-4", children: [
    /* @__PURE__ */ a.jsx(kt, {}),
    /* @__PURE__ */ a.jsx(qt, { className: "mt-6" }),
    (l = n.section) == null ? void 0 : l.map((e, s) => /* @__PURE__ */ a.jsx(Ht, { section: e }, s))
  ] });
}
function Xt({ bundle: r, downloadable: n }) {
  return /* @__PURE__ */ a.jsx(_t, { bundle: r, downloadable: n, children: /* @__PURE__ */ a.jsx(Jt, {}) });
}
export {
  Xt as HIProfile
};
//# sourceMappingURL=index.es.js.map
